module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_114_11.6d939ab7.pdf";